import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pickles: [],
  selectedPickle: null,
  loading: false,
  error: null,
};

const pickleSlice = createSlice({
  name: 'pickles',
  initialState,
  reducers: {
    fetchPicklesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPicklesSuccess: (state, action) => {
      state.loading = false;
      state.pickles = action.payload;
      state.error = null;
    },
    fetchPicklesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createPickleRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createPickleSuccess: (state, action) => {
      state.loading = false;
      state.pickles.push(action.payload);
      state.error = null;
    },
    createPickleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updatePickleRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatePickleSuccess: (state, action) => {
      state.loading = false;
      const index = state.pickles.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.pickles[index] = action.payload;
      }
      state.error = null;
    },
    updatePickleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deletePickleRequest: (state) => {
      state.loading = true;
    },
    deletePickleSuccess: (state, action) => {
      state.loading = false;
      state.pickles = state.pickles.filter(p => p.id !== action.payload);
    },
    deletePickleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchPicklesRequest,
  fetchPicklesSuccess,
  fetchPicklesFailure,
  createPickleRequest,
  createPickleSuccess,
  createPickleFailure,
  updatePickleRequest,
  updatePickleSuccess,
  updatePickleFailure,
  deletePickleRequest,
  deletePickleSuccess,
  deletePickleFailure,
} = pickleSlice.actions;

export default pickleSlice.reducer;